var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"pt-md-10 mt-md-10",attrs:{"color":"primary"}},[_c('v-row',[_c('v-col',{staticClass:"col-12"},[_c('copyright')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }